import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { SharedModule } from "app/_shared/shared.module";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { CalamityRoutingModule } from "./calamity-routing.module";
import { CalamityListComponent } from "./calamity-list/calamity-list.component";
import { CedFrameLayoutModule } from "ced-ng-library";
import { AgmCoreModule } from "@agm/core";
import { environment } from "environments/environment";
import { CalamityBasicDetailsComponent } from './calamity-details/calamity-basic-details/calamity-basic-details.component';
import { CalamityWizardComponent } from './calamity-details/calamity-wizard.component';
import { CalamityActionsListComponent } from './calamity-details/calamity-actions/calamity-actions-list/calamity-actions-list.component';
import { CalamityNotesListComponent } from './calamity-details/calamity-notes/calamity-notes-list/calamity-notes-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CalamityNoteDetailsComponent } from './calamity-details/calamity-notes/calamity-note-details/calamity-note-details.component';
import { CalamityDossierListComponent } from './calamity-dossier-list/calamity-dossier-list.component';
import { AddCalamityActionComponent } from "./calamity-details/calamity-actions/add-calamity-action/add-calamity-action.component";
import { OrganisationUnitsSearchActionComponent } from "./calamity-details/organisation-units-search-action/organisation-units-search-action.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    WindowModule,
    TreeViewModule,    
    CalamityRoutingModule,
    CedFrameLayoutModule,
    FontAwesomeModule,
    AgmCoreModule.forRoot({
      apiKey: environment.Keys.Google,
      libraries: ["places"]
    }),
  ],
  declarations: [CalamityListComponent,
    CalamityBasicDetailsComponent,
    CalamityWizardComponent,
    CalamityActionsListComponent,
    AddCalamityActionComponent,
    OrganisationUnitsSearchActionComponent,
    CalamityNotesListComponent,
    CalamityNoteDetailsComponent,
    CalamityDossierListComponent
  ],
  entryComponents:[
    AddCalamityActionComponent,
    OrganisationUnitsSearchActionComponent,
    CalamityNoteDetailsComponent
  ]
})
export class CalamityModule {}